import type { DropoffRow } from '../../lib/api'
import type { Variant, Audience } from '../../types'
import { stepLabel } from '../stepLabels'

interface Props {
  variant: Variant | undefined
  audience?: Audience
  rows: DropoffRow[] | null
  loading?: boolean
}

export function DropoffList({ variant, audience, rows, loading }: Props) {
  if (loading || !rows) return <div className="empty-state">Indlæser…</div>
  if (rows.length === 0) return <div className="empty-state muted">Ingen frafald registreret.</div>

  return (
    <ul className="dropoff-list">
      {rows.map((r) => (
        <li key={r.step}>
          <span>{variant ? stepLabel(variant, r.step, audience) : r.step}</span>
          <span className="dropoff-count">{r.n}</span>
        </li>
      ))}
    </ul>
  )
}
